import { createFileRoute } from "@tanstack/react-router";
import { SystemCapturePage } from "../../components/system/SystemCapturePage";
import { requireSuperAdmin } from "../../lib/auth/route-protection";

export const Route = createFileRoute("/system/capture")({
  beforeLoad: requireSuperAdmin(),
  component: SystemCaptureRoute,
});

function SystemCaptureRoute() {
  return <SystemCapturePage />;
}
